import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useEntitiesById } from "@hooks/useEntities";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { CatalogItemRow } from "../catalogItems.types";

export const EntityCell = memo(function EntityCell({
    row,
}: CellContext<ViewTableFeatures, CatalogItemRow, unknown>) {
    const item = row.original;
    const entitiesById = useEntitiesById();
    const entity = entitiesById.get(item.entityId);

    if (item.isNew || !entity) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <AvatarTooltip content={entity.name}>
                <EntityAvatar size="xs" entity={entity} copyId={entity.id} />
            </AvatarTooltip>
        </ViewTableCell>
    );
});
